var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"PLAY_PAUSE","name":"PLAY_PAUSE","data-vcode":"PLAY"}},[_c('img',{attrs:{"src":"/images/icons/playPause.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('playPauseButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }